'use es6';

import Client from 'AdsUI/data/Client';
const AUTH_BASE = `ads/v1/auth`;
const AD_ACCOUNTS_BASE = `ads/v1/ad-account`;
export const generateOAuthorKey = (network, networkUserId) => {
  return Client.apiRequest(`${AUTH_BASE}/${network.toLowerCase()}/${networkUserId}`, {
    type: 'POST'
  });
};
export const fetchAvailableAdAccounts = network => {
  return Client.apiRequest(`${AD_ACCOUNTS_BASE}/${network.toLowerCase()}/available`, {
    type: 'GET',
    timeout: 60000
  });
};
export const selectAdAccounts = (network, accountsWithTrackingStatus) => {
  return Client.apiRequest(`${AD_ACCOUNTS_BASE}/${network.toLowerCase()}/tracking`, {
    type: 'PUT',
    data: accountsWithTrackingStatus
  });
};
export const deleteAdAccount = (network, adAccountId) => {
  return Client.apiRequest(`${AD_ACCOUNTS_BASE}/${network.toLowerCase()}/${adAccountId}`, {
    type: 'DELETE'
  });
};
export const fetchConnectedAuths = () => {
  return Client.apiRequest(AUTH_BASE);
};
export const fetchScopes = network => {
  return Client.apiRequest(`${AUTH_BASE}/${network.toLowerCase()}/scopes`);
};
/**
 * Save the user's Facebook Extension token.
 * @param {string} adAccountId The user's Facebook account ID
 * @param {string} externalBusinessId The generated external business ID (comes from /ads/auth/facebook/business_extension/login)
 * @param {string} userToken The user token granted by Facebook
 */

export const saveFBEUserToken = (adAccountId, externalBusinessId, userToken) => {
  return Client.apiRequest(`${AUTH_BASE}/facebook/business_extension/user_token`, {
    type: 'POST',
    data: {
      adAccountId,
      externalBusinessId,
      userToken,
      sendAllEventsConsent: true
    }
  });
};